export default "__VITE_ASSET__CIj_AvcM__"